import React, { useState, useEffect, useMemo } from "react";
import { Link } from "react-router-dom";
import Button from "../components/button/index";
import CryptoJS from "crypto-js";
import Swal from "sweetalert2";

import {
  useConnectWallet,
  signWalletTransaction,
  getWalletAddress,
  getWalletChangeAddress,
} from "@newm.io/cardano-dapp-wallet-connector";

function Claiming() {
  const [selectedNFTs, setSelectedNFTs] = useState([]);
  const [selectedPolicyIds, setSelectedPolicyIds] = useState([]);
  const [stakeComponents, setStakeComponents] = useState([]);
  const [stakedNFTsArray, setExcludedAssetNames] = useState([]);
  const [stakedNFTsRewardInput, setStakedNFTsRewardInput] = useState([]);
  const [dynamicRewards, setDynamicRewards] = useState({});
  const [hasFetchedRewards, setHasFetchedRewards] = useState(false);
  const [assets, setAssets] = useState([]);
  const [policyIdFilter, setPolicyIdFilter] = useState(null);

  // NEW: split loading flags to avoid flicker
  const [loadingAssets, setLoadingAssets] = useState(false);
  const [loadingClaimed, setLoadingClaimed] = useState(false);
  const isLoading = loadingAssets || loadingClaimed;

  const { wallet, isConnected, getAddress, getChangeAddress } = useConnectWallet();

  const apiKey = process.env.REACT_APP_API_KEY || "";
  const stakeProjectId = process.env.REACT_APP_STAKE_PROJECT_ID || "";
  const nftDomain = "kwic";
  const BACKEND = process.env.REACT_APP_BACKEND_URL || "https://claiming.kwicdashboard.io";
  const maxSelectedNFTs = 50;

  const defaultPolicyId = "c72d0438330ed1346f4437fcc1c263ea38e933c1124c8d0f2abc6312";
  const targetPolicyIds = [
    "c72d0438330ed1346f4437fcc1c263ea38e933c1124c8d0f2abc6312",
    "cbb8d9d7415bbcc6f4c8a832d0437e9f6e7fe4605a1cf110ad903d82",
    "7c15d2a6be43f55000ae6ae0c31b9444a047815a8156df66d363c7a4",
    "b98ae818ee0693e61a8e51db1358240eaa441dba60a8c3766e3f5115",
    "cd1490083a247e1730d25cfbeed0ebfe57fa8c2697d7dba5fac9d2fa",
  ];

  const collectionType = {
    "c72d0438330ed1346f4437fcc1c263ea38e933c1124c8d0f2abc6312": "KWIC OG",
    "cbb8d9d7415bbcc6f4c8a832d0437e9f6e7fe4605a1cf110ad903d82": "KWIC 1 OF 1",
    "7c15d2a6be43f55000ae6ae0c31b9444a047815a8156df66d363c7a4": "KWIC ORDINAL REWARDS",
    "b98ae818ee0693e61a8e51db1358240eaa441dba60a8c3766e3f5115": "PLAYABLE AVATARS",
    "cd1490083a247e1730d25cfbeed0ebfe57fa8c2697d7dba5fac9d2fa": "PLAYABLE AVATAR SUMMONS",
  };

  const rewardsPerHour = {
    "c72d0438330ed1346f4437fcc1c263ea38e933c1124c8d0f2abc6312": "21,900 $KWIC",
    "cbb8d9d7415bbcc6f4c8a832d0437e9f6e7fe4605a1cf110ad903d82": "17,520 $KWIC",
    "7c15d2a6be43f55000ae6ae0c31b9444a047815a8156df66d363c7a4": "17,520 $KWIC",
    "b98ae818ee0693e61a8e51db1358240eaa441dba60a8c3766e3f5115": "8,212 $KWIC",
  };

  const collectionLinks = {
    "c72d0438330ed1346f4437fcc1c263ea38e933c1124c8d0f2abc6312": "https://www.jpg.store/collection/kwickeyboardwarriorsinternetcafe",
    "cbb8d9d7415bbcc6f4c8a832d0437e9f6e7fe4605a1cf110ad903d82": "https://www.jpg.store/collection/kwicart1of1",
    "7c15d2a6be43f55000ae6ae0c31b9444a047815a8156df66d363c7a4": "https://www.jpg.store/collection/kwicordinalrewards",
    "b98ae818ee0693e61a8e51db1358240eaa441dba60a8c3766e3f5115": "https://www.jpg.store/collection/kwicplayableavatars",
    "cd1490083a247e1730d25cfbeed0ebfe57fa8c2697d7dba5fac9d2fa": "https://www.jpg.store/collection/kwicplayableavatarsummons",
  };

  const stringToHex = (s) => Array.from(s).map(c => c.charCodeAt(0).toString(16).padStart(2, "0")).join("");
  const handleHexReplacement = (hex) => hex.replace(new RegExp(["000dfffd40","�@","á@"].join("|"),"g"), m => ({ "000dfffd40":"000de140","�@":"","á@":"" }[m]));
  const hexToString = (hex) => hex.replace(/(..)/g, (_,b) => String.fromCharCode(parseInt(b,16)));

  const allowedAssets = useMemo(
    () => Array.isArray(assets) ? assets.filter(a => targetPolicyIds.includes(a.policyId)) : [],
    [assets]
  );
  const filteredAssets = useMemo(
    () => allowedAssets.filter(a => !stakedNFTsArray.includes(a.assetName)),
    [allowedAssets, stakedNFTsArray]
  );

  const handleFilterButtonClick = (pid) => {
    setPolicyIdFilter(pid);
    setSelectedNFTs([]);
    setSelectedPolicyIds([]);
    setStakeComponents([]);
  };

  const handleNFTClick = (name, policyId) => {
    if (selectedNFTs.length >= maxSelectedNFTs && !selectedNFTs.includes(name)) {
      Swal.fire({ title: "MAX SELECTION REACHED", text: `You can only select up to ${maxSelectedNFTs} NFTs.`, icon: "warning" });
      return;
    }
    if (selectedNFTs.includes(name)) {
      setSelectedNFTs(selectedNFTs.filter(n => n !== name));
      setSelectedPolicyIds(selectedPolicyIds.filter(p => p !== policyId));
    } else {
      setSelectedNFTs([...selectedNFTs, name]);
      setSelectedPolicyIds([...selectedPolicyIds, policyId]);
    }
  };

  const handleSelectMax = () => {
    const visible = filteredAssets.filter(a => (policyIdFilter === null || a.policyId === policyIdFilter) && !selectedNFTs.includes(a.assetName));
    const pick = visible.slice(0, maxSelectedNFTs - selectedNFTs.length);
    const newNames = pick.map(a => a.assetName);
    const newPolicies = pick.map(a => a.policyId);
    setSelectedNFTs(prev => [...prev, ...newNames]);
    setSelectedPolicyIds(prev => [...prev, ...newPolicies]);
    const comps = pick.map(a => ({ stakeProjectId, policyId: a.policyId, assetName: handleHexReplacement(stringToHex(a.assetName)) }));
    setStakeComponents(prev => [...prev, ...comps]);
  };

  // Fetch assets (now reads data.assets OR falls back to array)
  useEffect(() => {
    const fetchAssetsForAddress = async () => {
      if (!wallet) return;
      setLoadingAssets(true);
      try {
        const addr = await getWalletAddress(wallet);
        const qs = encodeURIComponent(targetPolicyIds.join(","));
        // You can also append &flat=1 if you switch backend to plain array mode
        const url = `${BACKEND}/address-assets/${addr}?policyIds=${qs}`;
        const resp = await fetch(url);
        const data = await resp.json();
        const arr = Array.isArray(data?.assets) ? data.assets : (Array.isArray(data) ? data : []);
        setAssets(arr);
      } catch (e) {
        console.warn("Failed to fetch address assets:", e);
        setAssets([]);
      } finally {
        setLoadingAssets(false);
      }
    };
    if (isConnected && wallet) fetchAssetsForAddress();
    else setAssets([]);
  }, [wallet, isConnected]); // eslint-disable-line

  // Fetch claimed assets (separate loading flag)
  useEffect(() => {
    const fetchClaimedAssets = async () => {
      setLoadingClaimed(true);
      try {
        const r = await fetch(`${BACKEND}/claimed-assets`);
        const d = await r.json();
        setExcludedAssetNames(Array.isArray(d) ? d : []);
      } catch (e) {
        console.error("Failed to fetch claimed NFTs:", e);
      } finally {
        setLoadingClaimed(false);
      }
    };
    fetchClaimedAssets();
  }, []); // eslint-disable-line

  // Build reward input once we know allowed assets
  useEffect(() => {
    const buf = allowedAssets.map(item => ({
      policyId: item.policyId,
      assetName: handleHexReplacement(stringToHex(item.assetName)),
    }));
    setStakedNFTsRewardInput(buf);
  }, [allowedAssets]); // eslint-disable-line

  // Dynamic rewards (doesn't block initial render)
  useEffect(() => {
    const fetchRewards = async () => {
      const updated = {};
      for (const a of filteredAssets) {
        if (a.policyId !== "cd1490083a247e1730d25cfbeed0ebfe57fa8c2697d7dba5fac9d2fa") continue;
        try {
          const r = await fetch(`${BACKEND}/${a.policyId}${a.assetName}`);
          const m = await r.json();
          const wrapClass = m.onchain_metadata?.Class;
          const wrapType  = m.onchain_metadata?.Wrap;
          let tokenAmount = 0;
          if (wrapClass === "48577261705461696c") {
            if (wrapType === "46436f6d6d6f6e") tokenAmount = 21900;
            else if (wrapType === "48556e636f6d6d6f6e") tokenAmount = 27375;
            else if (wrapType === "4452617265") tokenAmount = 32850;
            else if (wrapType === "494c6567656e64617279") tokenAmount = 41062;
          } else if (wrapClass === "46526561706572") {
            if (wrapType === "46436f6d6d6f6e") tokenAmount = 82125;
            else if (wrapType === "48556e636f6d6d6f6e") tokenAmount = 90337;
            else if (wrapType === "4452617265") tokenAmount = 98550;
            else if (wrapType === "494c6567656e64617279") tokenAmount = 109500;
          }
          updated[a.assetName] = `${tokenAmount.toLocaleString()} $KWIC`;
        } catch {}
      }
      setDynamicRewards(updated);
      setHasFetchedRewards(true);
    };
    if (!hasFetchedRewards && filteredAssets.length > 0) fetchRewards();
  }, [filteredAssets, hasFetchedRewards]); // eslint-disable-line

  // Default filter
  useEffect(() => {
    setPolicyIdFilter(defaultPolicyId);
  }, []);

  const handleClaim = async (e) => {
    e.preventDefault();
    try {
      let timerInterval;
      Swal.fire({
        title: "PROCESSING!",
        html: "AWAITING TRANSACTION <b></b>",
        timer: 0, allowOutsideClick: false, allowEscapeKey: false, timerProgressBar: true,
        didOpen: () => {
          Swal.showLoading();
          const b = Swal.getHtmlContainer().querySelector("b");
          timerInterval = setInterval(() => (b.textContent = Swal.getTimerLeft()), 100);
        },
        willClose: () => clearInterval(timerInterval),
      });

      const selectedAssetUnits = selectedNFTs.map((name, i) => `${selectedPolicyIds[i]}${name}`);
      const refundWallet =
        (await getWalletChangeAddress(wallet)) ||
        (await new Promise((resolve) => getChangeAddress(resolve)));
      const claimMessage = `Claiming $KWIC for ${selectedNFTs.length} NFTs.`;

      const buildRes = await fetch(`${BACKEND}/build-claim`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ refundWallet, claimMessage, lovelace: "5589560", metadataLabel: 674, selectedAssetUnits }),
      });
      if (!buildRes.ok) throw new Error(`Build failed (${buildRes.status})`);
      const { unsignedTx } = await buildRes.json();

      const signedTx = await signWalletTransaction(wallet, unsignedTx, true);
      const txHash = await wallet.submitTx(signedTx);

      fetch(`${BACKEND}/verify-claim`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ txHash, selectedAssetUnits, selectedAssetName: selectedNFTs, refundWallet, selectedPolicyId: selectedPolicyIds }),
      }).catch(() => {});

      await Swal.fire({
        title: "CLAIM SUCCESSFUL!",
        html: "YOUR $KWIC TOKENS WILL BE SENT IN YOUR WALLET SHORTLY<b></b>",
        width: 600, padding: "3em", color: "#FFF",
        background: '#0007FF url(/images/trees.png)',
        allowOutsideClick: false, allowEscapeKey: false,
        backdrop: `rgba(0,0,0,0.8) url("/images/nyan-cat.gif") left top no-repeat`,
      });

      // eslint-disable-next-line no-restricted-globals
      location.reload();
    } catch (err) {
      const msg = (err && err.message) || String(err || "");
      if (msg == "user declined sign tx") {
        await Swal.fire({ title: "TRANSACTION CANCELLED!", html: "YOU CANCELLED THE TRANSACTION <b></b>", width: 600, padding: "3em", color: "#FFF", background: '#0007FF url(/images/trees.png)' });
        // eslint-disable-next-line no-restricted-globals
        location.reload();
        return;
      } else if (msg == "Build failed (400)"){
        await Swal.fire({ title: "AN ERROR OCCURED!", html: "TX BUILD FAILED, PLEASE MAKE SURE YOU HAVE ENOUGH ADA TO SUPPORT THE TX.", width: 600, padding: "3em", color: "#FFF", background: '#0007FF url(/images/trees.png)' });
        // eslint-disable-next-line no-restricted-globals
        location.reload();
        return;
      }
      await Swal.fire({
        title: "AN ERROR OCCURED!",
        html: msg.toLowerCase().includes("balance") || msg.toLowerCase().includes("fee")
          ? "YOU DONT HAVE ENOUGH ADA TO BUILD THE TRANSACTION. <b></b>"
          : "PLEASE TRY AGAIN LATER <b></b>",
        width: 600, padding: "3em", color: "#FFF", background: '#0007FF url(/images/trees.png)',
      });
    }
  };

  return (
    <div className="inner-page">
      <section className="tf-section project_2">
        {isConnected ? (
          <div className="container">
            <div className="row">
              <div className="col-lg-12">
                <div className="tf-title left mb-400 mt-40">
                  <div className="row">
                    <div className="col-lg-10">
                      <h3 className="title">SELECT NFT&apos;S</h3>
                      <h4 className="title">
                        SELECTED NFT&apos;S: <span className="selected_num">{selectedNFTs.length}</span>
                      </h4>
                    </div>
                    <div className="col-lg-2 page-button">
                      {selectedNFTs.length === 0 ? (
                        <Button title="CLAIM" addclass="stake_btn disabled" />
                      ) : (
                        <Button title="CLAIM" onClick={handleClaim} addclass="stake_btn" />
                      )}
                    </div>

                    <div className="col-lg-12 filter-wrapper">
                      {targetPolicyIds.map((pid) => (
                        <Button
                          key={pid}
                          title={collectionType[pid]}
                          onClick={() => handleFilterButtonClick(pid)}
                          addclass={`stake_btn filter ${policyIdFilter === pid ? "disabled" : ""}`}
                          disabled={policyIdFilter === pid}
                        />
                      ))}
                    </div>

                    <div className="col-lg-12 selector-btn">
                      {selectedNFTs.length >= 1 ? (
                        <Button
                          title="DESELECT ALL"
                          onClick={() => {
                            setSelectedNFTs([]);
                            setSelectedPolicyIds([]);
                            setStakeComponents([]);
                          }}
                          addclass="stake_btn select_max_btn"
                        />
                      ) : (
                        <Button
                          title="SELECT MAX NFT"
                          onClick={handleSelectMax}
                          addclass="stake_btn select_max_btn"
                          disabled={selectedNFTs.length >= maxSelectedNFTs}
                        />
                      )}
                    </div>
                  </div>
                </div>
              </div>

              {isLoading ? (
                <div>
                  <div className="col-lg-12 mb-100">
                    <div className="no-assets">
                      <span className="loader"></span>
                      <br />
                      <h4>CHECKING WALLET</h4>
                    </div>
                  </div>
                </div>
              ) : (
                <div>
                  <div className="col-lg-12">
                    <div className="project_wrapper_2">
                      {filteredAssets.filter(a => policyIdFilter === null || a.policyId === policyIdFilter).length === 0 ? (
                        <div className="no-available-asset mb-100">
                          <h3 className="text-center no-nft">NO AVAILABLE NFT&apos;S</h3>
                          <Button
                            title={`BUY ${collectionType[policyIdFilter]}`}
                            onClick={() => (window.location.href = collectionLinks[policyIdFilter])}
                            addclass="stake_btn buy_btn"
                          />
                        </div>
                      ) : (
                        filteredAssets
                          .filter(a => policyIdFilter === null || a.policyId === policyIdFilter)
                          .map((asset) => {
                            const collectionResult = collectionType[asset.policyId];
                            const rewardsResult = dynamicRewards[asset.assetName] || rewardsPerHour[asset.policyId];

                            const key = CryptoJS.enc.Base64.parse(apiKey);
                            const token = asset.fingerprint;
                            const buildUrl = (domain, token, uri, params) => {
                              const sp = new URLSearchParams(params);
                              return `https://${token}.${domain}.nftcdn.io${uri}?${sp.toString()}`;
                            };
                            const nftcdnUrl = (domain, key, token, uri, params = {}) => {
                              params.tk = "";
                              let url = buildUrl(domain, token, uri, params);
                              params.tk = CryptoJS.enc.Base64url.stringify(CryptoJS.HmacSHA256(url, key));
                              return buildUrl(domain, token, uri, params);
                            };
                            const originalImageUrl = nftcdnUrl(nftDomain, key, token, "/image", { size: 512 });

                            const stringAssetNames = hexToString(asset.assetName);
                            const replacements = { KWIC:"#", Summoned:"", OrdinalRewards:"", MulgaKong:"#", Playable:"", Avatar:"", "-":"", "#":"", " ":"", "á@":"", "�@":"" };
                            const regex = new RegExp(Object.keys(replacements).join("|"), "g");
                            const replacedString = stringAssetNames.replace(regex, m => replacements[m]);

                            return (
                              <div className="project-box-style7" key={asset.unit}>
                                {selectedNFTs.length === maxSelectedNFTs && !selectedNFTs.includes(asset.assetName) ? (
                                  <>
                                    <div className="nft_disabled"></div>
                                    <div className="nft_selection_full">
                                      <div className="image"><img src={originalImageUrl} alt="" /></div>
                                      <div className="content">
                                        <h5 className="heading">{replacedString}</h5>
                                        <ul>
                                          <li><p>{rewardsResult}</p></li>
                                          <li><p>{collectionResult}</p></li>
                                        </ul>
                                        <div className="content-progress-box style2">
                                          <div className="progress-bar" data-percentage="100%">
                                            <div className="progress-title-holder">
                                              <span className="progress-title">
                                                <span className="progress_number">
                                                  <span className="progress-number-mark" />
                                                </span>
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <Link
                                    key={asset.unit}
                                    alt={asset.assetName}
                                    className={`nft_selection ${selectedNFTs.includes(asset.assetName) ? "selected" : ""}`}
                                    onClick={() => handleNFTClick(asset.assetName, asset.policyId)}
                                  >
                                    <div className="image"><img src={originalImageUrl} alt="" /></div>
                                    <div className="content">
                                      <h5 className="heading">{replacedString}</h5>
                                      <ul>
                                        <li><p>{rewardsResult}</p></li>
                                        <li><p>{collectionResult}</p></li>
                                      </ul>
                                      <div className="content-progress-box style2">
                                        <div className="progress-bar" data-percentage="100%">
                                          <div className="progress-title-holder">
                                            <span className="progress-title">
                                              <span className="progress_number">
                                                <span className="progress-number-mark" />
                                              </span>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </Link>
                                )}
                              </div>
                            );
                          })
                      )}
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div className="container mb-100">
            <div className="row">
              <div className="col-lg-12">
                <div className="project_wrapper_2">
                  <div className="no-wallet-connected"><h2>CONNECT TO A WALLET</h2></div>
                </div>
              </div>
            </div>
          </div>
        )}
      </section>
    </div>
  );
}

export default Claiming;
